import { render, staticRenderFns } from "./PictureInfo.vue?vue&type=template&id=4eaaa7b4&scoped=true"
import script from "./PictureInfo.vue?vue&type=script&lang=ts"
export * from "./PictureInfo.vue?vue&type=script&lang=ts"
import style0 from "./PictureInfo.vue?vue&type=style&index=0&id=4eaaa7b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../src-custom-solutions/president-election/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eaaa7b4",
  null
  
)

export default component.exports